import { atom } from "recoil";
import { ItemDetailLineDto } from "../../types/dto/item-detail-line-dto";

export const isOpenPartnerProductOrderItemsSaveModal = atom<
  ItemDetailLineDto[]
>({
  key: "isOpenPartnerProductOrderItemsSaveModal",
  default: [],
});
